import React from 'react';
export function BonusSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-4" data-id="element-3">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-3" data-id="element-4">
            Más los <span className="text-[#FFD700]" data-id="element-5">6 Bonos Estratégicos</span>
          </h2>
          <p className="text-gray-400 text-base" data-id="element-6">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10" data-id="element-7">
          {/* Bono 1 */}
          <div className="bg-[#1a1400] border border-[#FFD700] rounded-2xl p-6 flex flex-col" data-id="element-8">
            <div className="text-4xl font-black text-[#FFD700] mb-1" data-id="element-9">01</div>
            <div className="text-[#FFD700] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-10">
              🎁 BONO 1
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-11">
              Planificador Anual "Año Cero-Estrés"
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-12">
              Convertí los 6 tomos en un calendario anual listo en 10 minutos.
              Incluye 3 velocidades de avance (Lento / Estándar / Rápido),
              calendarios trimestrales, plantilla de semana tipo y ejemplos
              reales para niños, adolescentes y adultos.
            </p>
            <div className="flex items-center gap-2" data-id="element-13">
              <span className="text-gray-400 line-through text-sm" data-id="element-14">$8.000</span>
              <span className="bg-[#FFD700] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-15">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 2 */}
          <div className="bg-[#1a1400] border border-[#FFD700] rounded-2xl p-6 flex flex-col" data-id="element-16">
            <div className="text-4xl font-black text-[#FFD700] mb-1" data-id="element-17">02</div>
            <div className="text-[#FFD700] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-18">
              🎁 BONO 2
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-19">
              Kit de Primera Clase Perfecta
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-20">
              Tu primera clase con cualquier alumno nuevo, resuelta. Guion
              completo para niños, adolescentes y adultos. Diagnóstico express
              de 7 minutos. Mini victoria en 15 minutos. Acuerdo de práctica y
              plan de 3 clases listo para entregar.
            </p>
            <div className="flex items-center gap-2" data-id="element-21">
              <span className="text-gray-400 line-through text-sm" data-id="element-22">$9.000</span>
              <span className="bg-[#FFD700] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-23">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 3 */}
          <div className="bg-[#1a1400] border border-[#FFD700] rounded-2xl p-6 flex flex-col" data-id="element-24">
            <div className="text-4xl font-black text-[#FFD700] mb-1" data-id="element-25">03</div>
            <div className="text-[#FFD700] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-26">
              🎁 BONO 3
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-27">
              Sistema de Tareas "Práctica Sin Peleas"
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-28">
              Tarjetas semanales listas (12 semanas), tracker de práctica para
              niños, plan "15 minutos" para adultos y scripts listos para
              WhatsApp a padres. El alumno practica en casa sin que tengas que
              rogarle.
            </p>
            <div className="flex items-center gap-2" data-id="element-29">
              <span className="text-gray-400 line-through text-sm" data-id="element-30">$8.000</span>
              <span className="bg-[#FFD700] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-31">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 4 */}
          <div className="bg-[#1a1400] border border-[#FFD700] rounded-2xl p-6 flex flex-col" data-id="element-32">
            <div className="text-4xl font-black text-[#FFD700] mb-1" data-id="element-33">04</div>
            <div className="text-[#FFD700] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-34">
              🎁 BONO 4
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-35">
              Pack de Evaluaciones Express + Rúbricas
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-36">
              6 evaluaciones listas (una por tomo) + rúbricas de corrección con
              escala 1-4 + plantilla de informe al alumno + script de devolución
              sin desmotivar + certificado trimestral imprimible.
            </p>
            <div className="flex items-center gap-2" data-id="element-37">
              <span className="text-gray-400 line-through text-sm" data-id="element-38">
                $10.000
              </span>
              <span className="bg-[#FFD700] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-39">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 5 */}
          <div className="bg-[#1a1400] border border-[#FFD700] rounded-2xl p-6 flex flex-col" data-id="element-40">
            <div className="text-4xl font-black text-[#FFD700] mb-1" data-id="element-41">05</div>
            <div className="text-[#FFD700] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-42">
              🎁 BONO 5
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-43">
              Banco de Frases del Profesor (Scripts)
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-44">
              60 frases listas para corregir, motivar y manejar situaciones
              difíciles. 12 mensajes de WhatsApp para padres. 4 guiones
              completos de conversaciones difíciles. Acuerdo de objetivos. 8
              cierres de clase poderosos.
            </p>
            <div className="flex items-center gap-2" data-id="element-45">
              <span className="text-gray-400 line-through text-sm" data-id="element-46">$9.000</span>
              <span className="bg-[#FFD700] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-47">
                GRATIS
              </span>
            </div>
          </div>

          {/* Bono 6 */}
          <div className="bg-[#1a1400] border border-[#FFD700] rounded-2xl p-6 flex flex-col" data-id="element-48">
            <div className="text-4xl font-black text-[#FFD700] mb-1" data-id="element-49">06</div>
            <div className="text-[#FFD700] text-xs font-bold uppercase tracking-widest mb-2" data-id="element-50">
              🎁 BONO 6
            </div>
            <h3 className="text-white font-black text-lg mb-2" data-id="element-51">
              Pack Clases Grupales Listas
            </h3>
            <p className="text-gray-400 text-sm flex-1 mb-4" data-id="element-52">
              Estructura minuto a minuto para clases de 45 y 60 minutos. 12
              dinámicas grupales sin tecnología. Sistema de estaciones y
              rotación. Niveles mixtos A/B/C. Planillas de asistencia y
              progreso. Reglas del aula imprimibles.
            </p>
            <div className="flex items-center gap-2" data-id="element-53">
              <span className="text-gray-400 line-through text-sm" data-id="element-54">$7.000</span>
              <span className="bg-[#FFD700] text-black font-black text-sm px-3 py-1 rounded-full" data-id="element-55">
                GRATIS
              </span>
            </div>
          </div>
        </div>

        <div className="border border-[#FFD700]/40 rounded-2xl p-6 text-center bg-[#0d0a00]" data-id="element-56">
          <p className="text-[#FFD700] text-sm font-semibold mb-1 uppercase tracking-widest" data-id="element-57">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-3 mb-2" data-id="element-58">
            <span className="text-gray-400 line-through text-lg" data-id="element-59">$51.000</span>
            <span className="text-[#FFD700] text-2xl font-black tracking-wide" data-id="element-60">
              🎁 GRATIS — Solo por hoy
            </span>
          </div>
          <p className="text-gray-400 text-sm" data-id="element-61">
            Incluidos en las ofertas. Siempre.
          </p>
        </div>
      </div>
    </section>;
}